import { render, staticRenderFns } from "./shequ.vue?vue&type=template&id=1fcba232&"
import script from "./shequ.vue?vue&type=script&lang=js&"
export * from "./shequ.vue?vue&type=script&lang=js&"
import style0 from "./shequ.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports